import React, {useState} from 'react'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {useForm} from 'react-hook-form'
import {PointsSummaryProps} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/PointsSummary'
import {
  useAutoUpdateSidebarItem,
  useEditSidebarItem,
} from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem'
import {Rule} from 'Event/attendee-rules'
import Settings from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/PointsSummary/PointsSummaryConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import Styling from 'Event/template/Lefty/Dashboard/Sidebar/SidebarItem/PointsSummary/PointsSummaryConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'

export function PointsSummaryConfig(
  props: ComponentConfigProps & {
    points: PointsSummaryProps
  },
) {
  const {showing, onClose, points} = props
  const {handleSubmit, control, watch, formState, setValue} = useForm()
  const {update, id: listId} = useEditSidebarItem()
  const [rules, setRules] = useState<Rule[]>(points.rules || [])

  const save = (data: PointsSummaryProps) => {
    const {summary, description} = data
    const localization = {
      [`sidebar_points_summary_list_${listId}_summary`]: summary || '',
      [`sidebar_points_summary_list_${listId}_description`]: description || '',
    }
    const updated = {
      ...data,
      summary: `{{sidebar_points_summary_list_${listId}_summary}}`,
      description: `{{sidebar_points_summary_list_${listId}_description}}`,
    }

    update({...updated, rules}, localization)
    onClose()
  }

  useAutoUpdateSidebarItem({
    item: watch(),
    when: showing,
  })

  return (
    <ComponentConfig
      title="Points"
      showing={showing}
      onClose={onClose}
      onSubmit={handleSubmit(save)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} points={points} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} points={points} />
      </StylingPanel>
      <RulesPanel rules={rules} setRules={setRules}>
        <ScheduleInput setValue={setValue} control={control} values={points} />
      </RulesPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
